import React from "react";

import { useFlags } from "launchdarkly-react-client-sdk";

import RedirectWithFlag from "../RedirectWithFlag";
import FinancialPlans from "@src/multiCustodian/pages/Client/:clientId/FinancialPlans/FinancialPlans";

export default function FinancialPlansDashboardRedirect(): JSX.Element {
  const { enableGoalBasedFinancialPlanning } = useFlags();

  return (
    <RedirectWithFlag
      flag={enableGoalBasedFinancialPlanning}
      redirectPath={"/Client"}
    >
      <FinancialPlans />
    </RedirectWithFlag>
  );
}
